// LS-BFCM-COUNTDOWN v1 (2026-10-06): one countdown for every BFCM placement (toolbar, collection, product page).
// The deadline is an absolute ISO instant with its offset (snippets/ls-bfcm-config.liquid), so every
// visitor counts down to the same moment whatever their time zone. The theme's own section-countdown.js
// parses "MM/DD/YYYY HH:MM" in the VISITOR's zone, which is why it is not used here.
// ?ls_cd_now=<ISO> shifts "now" for this page view only (testing the late and expired states).

export function remaining(deadlineMs, nowMs) {
  const ms = deadlineMs - nowMs;
  if (!(ms > 0)) return null;
  const s = Math.floor(ms / 1000);
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

const pad = (n) => String(n).padStart(2, '0');

if (typeof customElements !== 'undefined' && !customElements.get('ls-countdown')) {
  const override = Date.parse(new URLSearchParams(location.search).get('ls_cd_now') || '');
  const skew = Number.isNaN(override) ? 0 : override - Date.now();

  class LsCountdown extends HTMLElement {
    connectedCallback() {
      this.wrap = this.closest('[data-ls-bfcm]') || this;
      this.deadline = Date.parse(this.dataset.deadline || '');
      this.units = {};
      this.querySelectorAll('[data-unit]').forEach((el) => { this.units[el.dataset.unit] = el; });
      if (Number.isNaN(this.deadline)) { this.wrap.remove(); return; }
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const left = remaining(this.deadline, Date.now() + skew);
      if (!left) {
        clearInterval(this.timer);
        this.wrap.remove();
        return;
      }
      if (this.units.d) this.units.d.textContent = left.d;
      if (this.units.h) this.units.h.textContent = pad(left.h);
      if (this.units.m) this.units.m.textContent = pad(left.m);
      if (this.units.s) this.units.s.textContent = pad(left.s);
      this.wrap.classList.add('is-ready');
    }
  }

  customElements.define('ls-countdown', LsCountdown);
}
